import axios from 'axios'
import InMemoryJWT from '../../../../Auth/inMemoryJWT'
import { apiUrl } from '../../../../helpers/config'
import {
  CarCounterInterface,
  CarwashOfflinePayment,
  CarwashOnlinePayment,
  EventInterface,
} from '../interfaces'

type Props = {
  carwashId?: string[]
  lastSeenLte: string
  lastSeenGte: string
}

const makeUrlParams = (
  lte: string,
  gte: string,
  carwashId?: string[]
): string => {
  let str = '?_end=10000000&_order=ASC&_sort=id&_start=0'
  str += `&last_seen_lte=${lte}`
  str += `&last_seen_gte=${gte}`
  if (!carwashId || carwashId.length === 0) return str
  carwashId.forEach((item) => {
    str += `&carwashId=${item}`
  })
  return str
}

export const getOfflinePayments = ({
  lastSeenLte,
  lastSeenGte,
  carwashId,
}: Props): Promise<CarwashOfflinePayment[]> =>
  new Promise(async (resolve, reject) => {
    try {
      const token = InMemoryJWT.getToken()
      if (!token) await InMemoryJWT.getRefreshedToken()
      const result = await axios.get<CarwashOfflinePayment[]>(
        `${apiUrl}/admin/carwash-stat/payment/report${makeUrlParams(
          new Date(lastSeenLte).toISOString(),
          new Date(lastSeenGte).toISOString(),
          carwashId
        )}`,
        {
          timeout: 30000,
          headers: {
            Authorization: `Bearer ${InMemoryJWT.getToken()}`,
          },
        }
      )
      resolve(result.data)
    } catch (error) {
      console.log('get carwash offline payments error: ', error)
      reject(error)
    }
  })

export const getOnlinePayments = ({
  lastSeenLte,
  lastSeenGte,
  carwashId,
}: Props): Promise<CarwashOnlinePayment[]> =>
  new Promise(async (resolve, reject) => {
    try {
      const token = InMemoryJWT.getToken()
      if (!token) await InMemoryJWT.getRefreshedToken()
      const result = await axios.get<CarwashOnlinePayment[]>(
        `${apiUrl}/admin/transactions${makeUrlParams(
          new Date(lastSeenLte).toISOString(),
          new Date(lastSeenGte).toISOString(),
          carwashId
        )}`,
        {
          timeout: 30000,
          headers: {
            Authorization: `Bearer ${InMemoryJWT.getToken()}`,
          },
        }
      )
      resolve(result.data)
    } catch (error) {
      console.log('get carwash online payments error: ', error)
      reject(error)
    }
  })

export const getCarCounterList = ({
  lastSeenLte,
  lastSeenGte,
  carwashId,
}: Props): Promise<CarCounterInterface[]> =>
  new Promise(async (resolve, reject) => {
    try {
      const token = InMemoryJWT.getToken()
      if (!token) await InMemoryJWT.getRefreshedToken()
      const result = await axios.get<CarCounterInterface[]>(
        `${apiUrl}/admin/carCounterList${makeUrlParams(
          new Date(lastSeenLte).toISOString(),
          new Date(lastSeenGte).toISOString(),
          carwashId
        )}`,
        {
          timeout: 30000,
          headers: {
            Authorization: `Bearer ${InMemoryJWT.getToken()}`,
          },
        }
      )
      resolve(result.data)
    } catch (error) {
      console.log('get car counter list error: ', error)
      reject(error)
    }
  })

export const getEventsList = ({
  lastSeenLte,
  lastSeenGte,
  carwashId,
}: Props): Promise<EventInterface[]> =>
  new Promise(async (resolve, reject) => {
    try {
      const token = InMemoryJWT.getToken()
      if (!token) await InMemoryJWT.getRefreshedToken()
      const result = await axios.get<EventInterface[]>(
        `${apiUrl}/admin/carwash-stat/event/report${makeUrlParams(
          new Date(lastSeenLte).toISOString(),
          new Date(lastSeenGte).toISOString(),
          carwashId
        )}`,
        {
          timeout: 30000,
          headers: {
            Authorization: `Bearer ${InMemoryJWT.getToken()}`,
          },
        }
      )
      resolve(result.data)
    } catch (error) {
      console.log('get events list error: ', error)
      reject(error)
    }
  })
